import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { useSelector, useDispatch } from "react-redux";

import CmtCard from "@coremat/CmtCard";
import CmtCardContent from "@coremat/CmtCard/CmtCardContent";

import AllUsersTable from "./AllUsersTable";
import { Box } from "@material-ui/core";
import CmtSearch from "@coremat/CmtSearch";
import { setUserSearchParams } from "redux/actions/Users";

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    [theme.breakpoints.down("xs")]: {
      "& .Cmt-header-root": {
        flexDirection: "column",
      },
      "& .Cmt-action-default-menu": {
        marginLeft: 0,
        marginTop: 10,
      },
    },
  },
  cardContentRoot: {
    padding: 0,
  },
  scrollbarRoot: {
    height: 275,
  },
  searchContainer: {
    padding: "20px 20px",
  },
}));

const AllUsers = () => {
  const classes = useStyles();
  const { userSearchParams } = useSelector(({ users }) => users);
  const dispatch = useDispatch();
  return (
    <CmtCard className={classes.cardRoot}>
      <Box className={classes.searchContainer}>
        <CmtSearch
          border={false}
          onlyIcon={false}
          iconPosition="left"
          align="left"
          placeholder="جست و جو"
          value={userSearchParams}
          onChange={(e) => dispatch(setUserSearchParams(e.target.value))}
        />
      </Box>
      <CmtCardContent className={classes.cardContentRoot}>
        <AllUsersTable />
      </CmtCardContent>
    </CmtCard>
  );
};

export default AllUsers;
